import { Pipe, PipeTransform } from '@angular/core';

import { Fai, ProductFactory, Subscription } from '@bytel/bytel-sales';
import { CommercialSeries } from '@bytel/checkout';

@Pipe({
    name: 'isIndiana',
    standalone: true,
})

/**
 * Pipe permettant d'afficher ou non le bloc XBOX pour le projet INDIANA
 */
export class IndianaPipe implements PipeTransform {
    transform(plan: Subscription): boolean {
        if (plan && ProductFactory.Is(plan, Fai)) {
            return plan.data.commercial_series === CommercialSeries.GAMING;
        } else {
            return false;
        }
    }
}
